import { Component, Input, OnInit } from '@angular/core';
import { ModalController, AlertController } from '@ionic/angular';
import { JavapiService } from '../../services/javapi.service';
import { Metodosui } from '../../services/metodosui';
import { Modelogeneraldatos } from '../../models/modelogeneraldatos';

import { ComponentesGenericosComponent } from '../componentes-genericos/componentes-genericos.component';

@Component({
  selector: 'app-admin-crud-edit-modal',
  templateUrl: './admin-crud-edit-modal.component.html',
  styleUrls: ['./admin-crud-edit-modal.component.scss'],
  standalone: false
})
export class AdminCrudEditModalComponent implements OnInit {
  @Input() entity: string = '';
  @Input() entityName: string = '';
  @Input() iconName: string = 'cube-outline';
  @Input() iconColor: string = '#5b8af5';
  @Input() isEditing: boolean = false;
  @Input() item: any = {};
  @Input() entityFields: any[] = [];
  @Input() groups: Modelogeneraldatos[] = [];
  @Input() rawSolicitorsList: Modelogeneraldatos[] = [];
  @Input() allItems: Modelogeneraldatos[] = [];

  currentData: any = {};
  loading: boolean = false;

  constructor(
    private modalCtrl: ModalController,
    private alertCtrl: AlertController,
    private javapi: JavapiService,
    private metodosUi: Metodosui
  ) {}

  ngOnInit() {
    this.initData();
  }

  initData() {
    if (this.isEditing && this.item) {
      this.currentData = { ...this.item };
    } else {
      this.currentData = { dt1: '0', dt4: 'V', ...(this.item || {}) };
    }
  }

  closeModal(updated: boolean = false, deleted: boolean = false, insertedData?: any) {
    this.modalCtrl.dismiss({ updated, deleted, insertedData });
  }

  getFieldOptions(field: any): { id: string; nombre: string }[] {
    if ((this.entity === 'DIRECCION' || this.entity === 'SOLICITANTE') && field.key === 'dt3') {
      return this.getFilteredGroups().map(g => ({ id: String(g.val), nombre: g.text }));
    }
    return (field.options || []).map((o: any) => ({ id: String(o.val), nombre: o.text }));
  }

  getSelectedOptionLabel(field: any): string {
    const val = this.currentData[field.key];
    if (val === undefined || val === null || val === '') return '';
    const options = this.getFieldOptions(field);
    const found = options.find(o => String(o.id) === String(val));
    return found ? found.nombre : String(val);
  }

  async openGenericSelector(field: any) {
    const options = this.getFieldOptions(field);
    const currentValue = this.currentData[field.key];

    let genericEntity: any = 'CLIENTE';
    const labelLower = (field.label || '').toLowerCase();
    if (labelLower.includes('cliente')) genericEntity = 'CLIENTE';
    else if (labelLower.includes('direcci') || labelLower.includes('sucursal')) genericEntity = 'DIRECCION';
    else if (labelLower.includes('solicitante')) genericEntity = 'SOLICITANTE';
    else if (labelLower.includes('area') || labelLower.includes('área')) genericEntity = 'AREA';
    else if (labelLower.includes('estructura')) genericEntity = 'ESTRUCTURA';
    else if (labelLower.includes('subcontratista')) genericEntity = 'SUBCONTRATISTA';
    else if (labelLower.includes('unidad')) genericEntity = 'UNIDAD';
    else if (labelLower.includes('turno')) genericEntity = 'TURNO';

    const modal = await this.modalCtrl.create({
      component: ComponentesGenericosComponent,
      componentProps: {
        entity: genericEntity,
        title: `Seleccionar ${field.label}`,
        placeholder: `Buscar ${field.label.toLowerCase()}...`,
        items: options,
        initialSearch: '',
        selectedIds: currentValue ? [String(currentValue)] : [],
        isMultiSelect: false
      }
    });

    await modal.present();
    const { data } = await modal.onWillDismiss();
    if (data && data.selected) {
      this.currentData[field.key] = String(data.selected.id);
    }
  }

  getFilteredGroups() {
    const clientId = this.entity === 'SOLICITANTE' ? this.currentData.dt6 : this.currentData.dt2;
    if (!clientId) return [];
    return this.groups
      .filter(g => g.dt2 === clientId)
      .map(g => ({ val: g.dt1, text: g.dt3 }));
  }

  getSolicitanteClients(solicitanteId: string): { id: number; nombre: string }[] {
    if (!solicitanteId || this.entity !== 'SOLICITANTE') return [];
    return this.rawSolicitorsList
      .filter(s => s.dt1 === solicitanteId && s.dt6 && s.dt11)
      .map(s => ({ id: Number(s.dt6), nombre: s.dt11 }));
  }

  unlinkClient(solicitanteId: string, clienteId: number) {
    if (!solicitanteId || !clienteId) return;
    this.javapi.executeAdminCrud('SOLICITANTE', 'UNLINK_CLIENTE', {
      dt1: solicitanteId,
      dt6: clienteId.toString()
    }).subscribe({
      next: () => {
        this.rawSolicitorsList = this.rawSolicitorsList.filter(
          s => !(s.dt1 === solicitanteId && Number(s.dt6) === clienteId)
        );
        this.metodosUi.showToast('Cliente desvinculado', 'success', 'bottom');
      },
      error: () => {
        this.metodosUi.showToast('Error al desvincular cliente', 'danger', 'bottom');
      }
    });
  }

  getFieldIcon(label: string): string {
    if (!label) return 'information-circle-outline';
    const l = label.toLowerCase();
    if (l.includes('nombre') || l.includes('cliente') || l.includes('solicitante')) return 'person-outline';
    if (l.includes('correo') || l.includes('email')) return 'mail-outline';
    if (l.includes('teléfono') || l.includes('celular')) return 'call-outline';
    if (l.includes('título')) return 'bookmark-outline';
    if (l.includes('texto') || l.includes('descripción') || l.includes('observación')) return 'document-text-outline';
    if (l.includes('costo') || l.includes('valor') || l.includes('precio')) return 'cash-outline';
    if (l.includes('dirección') || l.includes('sucursal') || l.includes('lugar')) return 'location-outline';
    if (l.includes('rol')) return 'briefcase-outline';
    if (l.includes('activo')) return 'power-outline';
    if (l.includes('grupo') || l.includes('notificación')) return 'people-outline';
    if (l.includes('región')) return 'map-outline';
    if (l.includes('unidad')) return 'thermometer-outline';
    if (l.includes('cantidad')) return 'calculator-outline';
    return 'information-circle-outline';
  }

  getJsonParamName(): string {
    switch (this.entity) {
      case 'PLANTILLA_OBS': return 'config_plantillas_obs';
      case 'PLANTILLA_PAGOS': return 'config_plantillas_pagos';
      case 'COMERCIO': return 'config_comercios';
      case 'GASTO_CATEGORIA': return 'config_gastos_categorias';
      case 'ACTIVIDAD': return 'config_actividades';
      case 'CANTIDAD': return 'config_cantidades';
      case 'UNIDAD': return 'config_unidades';
      default: return '';
    }
  }

  async saveItem() {
    this.loading = true;

    if (['PLANTILLA_OBS', 'PLANTILLA_PAGOS', 'COMERCIO', 'GASTO_CATEGORIA', 'ACTIVIDAD', 'CANTIDAD', 'UNIDAD'].includes(this.entity)) {
      const paramName = this.getJsonParamName();
      let dataList: any[] = [];

      if (this.entity === 'PLANTILLA_OBS' || this.entity === 'PLANTILLA_PAGOS') {
        dataList = this.allItems.map(i => ({ titulo: i.dt2, texto: i.dt3 }));
        if (this.isEditing) {
          dataList[parseInt(this.currentData.dt1)] = { titulo: this.currentData.dt2, texto: this.currentData.dt3 };
        } else {
          dataList.push({ titulo: this.currentData.dt2, texto: this.currentData.dt3 });
        }
      } else {
        if (this.entity === 'CANTIDAD') {
          dataList = this.allItems.map(i => ({ nombre: i.dt2, abreviatura: i.dt3 }));
          if (this.isEditing) {
            dataList[parseInt(this.currentData.dt1)] = { nombre: this.currentData.dt2, abreviatura: this.currentData.dt3 };
          } else {
            dataList.push({ nombre: this.currentData.dt2, abreviatura: this.currentData.dt3 });
          }
        } else if (this.entity === 'UNIDAD') {
          dataList = this.allItems.map(i => i.dt2);
          if (this.isEditing) {
            dataList[parseInt(this.currentData.dt1)] = this.currentData.dt2;
          } else {
            dataList.push(this.currentData.dt2);
          }
        } else {
          dataList = this.allItems.map(i => ({ id: i.dt1, nombre: i.dt2 }));
          if (this.isEditing) {
            const idx = dataList.findIndex(i => i.id === this.currentData.dt1);
            if (idx !== -1) dataList[idx] = { id: this.currentData.dt1, nombre: this.currentData.dt2 };
          } else {
            const nextId = this.allItems.length > 0 ? (Math.max(...this.allItems.map(i => parseInt(i.dt1))) + 1).toString() : '1';
            dataList.push({ id: nextId, nombre: this.currentData.dt2 });
          }
        }
      }

      this.javapi.saveJsonParam(paramName, JSON.stringify(dataList)).subscribe({
        next: () => {
          this.loading = false;
          this.metodosUi.showToast('Guardado exitosamente', 'success', 'bottom');
          this.closeModal(true);
        },
        error: () => {
          this.loading = false;
          this.metodosUi.showToast('Error al guardar', 'danger', 'bottom');
        }
      });
      return;
    }

    const action = this.isEditing ? 'UPDATE' : 'INSERT';
    this.javapi.executeAdminCrud(this.entity, action, this.currentData).subscribe({
      next: (res: any) => {
        this.loading = false;
        this.metodosUi.showToast('Guardado exitosamente', 'success', 'bottom');
        const newId = Array.isArray(res) ? res[0]?.dt1 : (res?.dt1 || this.currentData.dt1);
        const newName = this.currentData.dt2 || this.currentData.dt5;
        this.closeModal(true, false, { id: newId, nombre: newName });
      },
      error: () => {
        this.loading = false;
        this.metodosUi.showToast('Error al guardar', 'danger', 'bottom');
      }
    });
  }

  async confirmDelete() {
    const alert = await this.alertCtrl.create({
      header: 'Confirmar Eliminación',
      message: `¿Estás seguro de que deseas eliminar este registro (${this.entityName})?`,
      buttons: [
        { text: 'Cancelar', role: 'cancel' },
        {
          text: 'Eliminar',
          role: 'destructive',
          handler: () => {
            this.executeDelete();
          }
        }
      ]
    });
    await alert.present();
  }

  executeDelete() {
    this.loading = true;

    if (['PLANTILLA_OBS', 'PLANTILLA_PAGOS', 'COMERCIO', 'GASTO_CATEGORIA', 'ACTIVIDAD', 'CANTIDAD', 'UNIDAD'].includes(this.entity)) {
      const paramName = this.getJsonParamName();
      let dataList: any[] = [];

      if (this.entity === 'PLANTILLA_OBS' || this.entity === 'PLANTILLA_PAGOS') {
        dataList = this.allItems.map(i => ({ titulo: i.dt2, texto: i.dt3 }));
        dataList.splice(parseInt(this.currentData.dt1), 1);
      } else if (this.entity === 'CANTIDAD') {
        dataList = this.allItems.map(i => ({ nombre: i.dt2, abreviatura: i.dt3 }));
        dataList.splice(parseInt(this.currentData.dt1), 1);
      } else if (this.entity === 'UNIDAD') {
        dataList = this.allItems.map(i => i.dt2);
        dataList.splice(parseInt(this.currentData.dt1), 1);
      } else {
        dataList = this.allItems.map(i => ({ id: i.dt1, nombre: i.dt2 }));
        dataList = dataList.filter(i => i.id !== this.currentData.dt1);
      }

      this.javapi.saveJsonParam(paramName, JSON.stringify(dataList)).subscribe({
        next: () => {
          this.loading = false;
          this.metodosUi.showToast('Registro eliminado', 'warning', 'bottom');
          this.closeModal(false, true);
        },
        error: () => {
          this.loading = false;
          this.metodosUi.showToast('Error al eliminar', 'danger', 'bottom');
        }
      });
      return;
    }

    this.javapi.executeAdminCrud(this.entity, 'DELETE', this.currentData).subscribe({
      next: () => {
        this.loading = false;
        this.metodosUi.showToast('Registro eliminado', 'warning', 'bottom');
        this.closeModal(false, true);
      },
      error: () => {
        this.loading = false;
        this.metodosUi.showToast('Error al eliminar', 'danger', 'bottom');
      }
    });
  }
}
